import React from 'react'
import bg from './img5/hotel6.jpg'
import well from './img5/well.jpg'
import room from './img5/room.png'
import dining from './img5/dining.jpg'
import spa from './img5/spa.webp'
import im from './img5/beach.png'
import im1 from './img5/hotel4.webp'
import im2 from './img5/photo.png'
import im3 from './img5/imag.png'
import './Home.css';
import Header from '../Header'
import Footer from '../Footer'
import ScrollButtons from '../ScrollButtons'
export default function Home() {
  return (
    <div>
      <Header/>
      <ScrollButtons/>
    <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={bg} className='d-block w-100'style={{height:"550px"}}/>
      <div className='text-overplay'>
        <h1 style={{fontSize:"40px", fontWeight:"bolder", color:"white"}}>Welcome to Our Hotel</h1>
      </div>
    </div>
</div>

<div className='container'>
  <div className='row'>
    <div className='col-sm-1'></div>
    <div className='col-sm-5'style={{marginTop:"20px"}}>
    <h1 style={{fontWeight:"bolder"}}>Welcome!</h1>
    <p style={{fontSize:"20px", textAlign:"justify"}}> Welcome to the Management System, where efficiency and exceptional guest service meet. Our system is designed to streamline all aspects of hotel operations, ensuring smooth and effortless management from check-in to check-out.Far far away,behind the world monuntains,far
   from the countries vkalia and consonatia,
    thier live the blinds texts separeted they live in 
   bookmarksgrove Rights at the coast of the semanitics
    a large langauge ocean</p>
    </div>
    <div className='col-sm-5 wel'>
    <img src={well} style={{height:"450px", marginTop:"20px"}}/>
    </div>
    <div className='col-sm-1'></div>
  </div>
</div>
<div className='container'>
  <div className='row'>
    <h1 style={{fontWeight:"bolder"}}>Our service</h1>
    <div className='col-sm-3 img' style={{marginLeft:"50px"}}>
  <img src={room} className="card-img-top" alt="..."style={{width: "18rem"}}/>
  <div class="card-body">
    <h5 className="card-title">Luxury Rooms</h5>
    <p class="card-text">luxury room ek aisi jaga hoti hai jahan har chhoti se chhoti cheez ko dhyan me rakhkar suvidhaon aur comfort ka vichar kiya jata hai. </p>
    <a href="#" className="btn btn-primary">Read more</a>
  </div>
  </div>
  <div className='col-sm-3' style={{marginLeft:"80px"}}>
  
  <img src={dining} className="card-img-top" alt="..." style={{width: "18rem"}}/>
  <div class="card-body">
    <h5 className="card-title">Dining</h5>
    <p class="card-text">A dining room offers a refined space for guests to enjoy gourmet meals in a sophisticated and comfortable setting. </p>
    <a href="#" className="btn btn-primary">Read more</a>
  </div>
  </div>
  <div className='col-sm-3'style={{marginLeft:"80px"}}>
  <img src={spa} className="card-img-top" alt="..."style={{width: "18rem"}}/>
  <div class="card-body">
    <h5 className="card-title">Spa & Wellness</h5>
    <p class="card-text">Spa & Wellness ek aisa anubhav hai jisme relaxation, rejuvenation aur stress relief ke liye alag-alag therapies .</p>
    <a href="#" className="btn btn-primary">Read more </a>
  </div>
  </div>
  </div>
  </div>
  <div className="container" style={{ marginTop: "20px", marginBottom: "20px" }}>
      <div className="row">
        {/* First Image */}
        <div className="col-sm-3 mb-4">
          <div className="card">
            <img src={im} className="card-img-top" style={{ height: "180px", objectFit: "cover" }} alt="Hotel 1" />
            <div className="card-body">
              <h5 className="card-title">Hotel Name 1</h5>
              <p className="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis euismod, nunc et fermentum posuere, sapien nisi consequat purus.</p>
            </div>
          </div>
        </div>

        {/* Second Image */}
        <div className="col-sm-3 mb-4">
          <div className="card">
            <img src={im1} className="card-img-top" style={{ height: "180px", objectFit: "cover" }} alt="Hotel 2" />
            <div className="card-body">
              <h5 className="card-title">Hotel Name 2</h5>
              <p className="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis euismod, nunc et fermentum posuere, sapien nisi consequat purus.</p>
            </div>
          </div>
        </div>

        {/* Third Image */}
        <div className="col-sm-3 mb-4">
          <div className="card">
            <img src={im2} className="card-img-top" style={{ height: "180px", objectFit: "cover" }} alt="Hotel 3" />
            <div className="card-body">
              <h5 className="card-title">Hotel Name 3</h5>
              <p className="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis euismod, nunc et fermentum posuere, sapien nisi consequat purus.</p>
            </div>
          </div>
        </div>

        {/* Fourth Image (Added new one) */}
        <div className="col-sm-3 mb-4">
          <div className="card">
            <img src={im3} className="card-img-top" style={{ height: "180px", objectFit: "cover" }} alt="Hotel 4" />
            <div className="card-body">
              <h5 className="card-title">Hotel Name 4</h5>
              <p className="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis euismod, nunc et fermentum posuere, sapien nisi consequat purus.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
 
  )
}